<template>
  <a href="#" class="card">
    <img src="/images/temp/promo_bg.png" class="card-img" alt="">
    <div class="card-img-overlay">
      <div>
        <h3 class="h5 card-title" v-show="title">{{title}}</h3>
        <p class="card-text" v-show="price">
          <span v-show="!fixedPrice">od </span><span class="card-price">{{price}}</span>
        </p>
        <div class="btn btn-warning link stretched-link">Kup bilet</div>
      </div>
    </div>
  </a>
</template>
<script>

export default {
  name: 'offer',
  props: {
    title: {
      type: String,
    },
    price: {
      type: String,
    },
    fixedPrice: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {}
  }
}
</script>>